import {FormValidator} from "../../../tools/form/form-validator";
import {UploadFormModel} from "../../upload/upload-form-model";
import {createMeasurementFormValidationMap, UploadDataValidationConfig} from "../../upload/create-measurement-form-validation-map";

export class EFormValidator extends FormValidator<UploadFormModel> {

  constructor(uploadData: UploadFormModel, config: UploadDataValidationConfig) {
    super(createMeasurementEFormValidationMap(uploadData, config));
  }
}

function createMeasurementEFormValidationMap(
  uploadData: UploadFormModel,
  config: UploadDataValidationConfig
): Map<keyof UploadFormModel, () => boolean> {
  return new Map([
    ...createMeasurementFormValidationMap(uploadData, config)
      .entries()
  ]
    .filter((pair) => ["gender", "dateOfBirth", "age", "height", "weight"].includes(pair[0])));
}
